import CreateBank from "components/ManageBank/CreateBank";
import NotFooterLayout from "layouts/NotFooterLayout";
 

function CreateBankPage() {

  return (
    <NotFooterLayout namePage="เพิ่มบัญชี" >
      <div className="layout-content">
        <CreateBank />
      </div>
    </NotFooterLayout>
  );
}

export default CreateBankPage;